import { localStorage } from 'dibs-browser-storage';

const HAS_SEEN_FAVORITES_TOOLTIP = 'HAS_SEEN_FAVORITES_TOOLTIP';

export function hasSeenFavoritesTooltip() {
    return localStorage.getItem(HAS_SEEN_FAVORITES_TOOLTIP) || false;
}

export function logFavoritesTooltipView() {
    localStorage.setItem(HAS_SEEN_FAVORITES_TOOLTIP, true);
}
